export default "__VITE_ASSET__B3$CO3PV__"